import { ReportingControllerBaseConfig } from '../../../base';
import { SnippetOverlayController } from './snippetOverlayInterface';
import { SnippetOverlayViewProps } from './snippetOverlayProps';

export function createSnippetOverlayController(
    config: ReportingControllerBaseConfig
): SnippetOverlayController {
    return {
        useProps(context, item, props): SnippetOverlayViewProps {
            return {
                modal: {
                    isOpen: props.disclosure.isOpen,
                    onClose: props.disclosure.onClose,
                },
                detail: props.snippet
                    ? {
                          snippet: props.snippet,
                          onCancel: props.disclosure.onClose,
                      }
                    : null,
            };
        },
    };
}
